const toTeamMemberId = (teamId, userId) => `${userId}::${teamId}`

export default toTeamMemberId
